<template>
  <validation-observer tag="div" ref="form">
    <validation-provider
        class="col-md-5"
        :vid="`customer_id`"
        :name="lodash.upperFirst($t('bank_accounts.customer'))"
        rules="required"
        v-slot="{ validated, errors }"
    >
      <b-form-group
          class="row mb-3"
          label-cols-md="2"
          :label="`${lodash.upperFirst($t('bank_accounts.customer'))}*`"
          :state="errors[0] ? false : (validated ? true : null)"
          :invalid-feedback="errors[0]"
      >
        <VueMultiselectAjax
            :key="`${_uid}-customers`"
            name="customer_id"
            v-model.number="model.customer_id"
            url="/customers"
            :params="{ sort: 'name,asc' }"
        ></VueMultiselectAjax>
      </b-form-group>
    </validation-provider>
    <validation-provider
        class="col-md-5" :vid="`name`"
        :name="lodash.upperFirst($t('bank_accounts.name'))"
        rules="required" v-slot="{ validated, errors }"
    >
      <b-form-group
          class="row mb-3"
          label-cols-md="2"
          :label="`${lodash.upperFirst($t('bank_accounts.name'))}*`"
          :state="errors[0] ? false : (validated ? true : null)"
          :invalid-feedback="errors[0]"
      >
        <b-form-input
            id="name"
            :name="`name`"
            type="text"
            placeholder="Ex: John"
            :state="errors[0] ? false : (validated ? true : null)"
            v-model="model.name"
        ></b-form-input>
      </b-form-group>
    </validation-provider>
    <validation-provider
        class="col-md-5"
        :vid="`bank_id`"
        :name="lodash.upperFirst($t('bank_accounts.bank'))"
        rules="required"
        v-slot="{ validated, errors }"
    >
      <b-form-group
          class="row mb-3"
          label-cols-md="2"
          :label="`${lodash.upperFirst($t('bank_accounts.bank'))}*`"
          :state="errors[0] ? false : (validated ? true : null)"
          :invalid-feedback="errors[0]"
      >
        <VueMultiselectAjax
            :key="`${_uid}-customers`"
            name="bank_id"
            v-model.number="model.bank_id"
            url="/banks"
            :params="{ sort: 'name,asc' }"
        ></VueMultiselectAjax>
      </b-form-group>
    </validation-provider>
    <validation-provider
        class="col-md-5" :vid="`account_number`"
        :name="lodash.upperFirst($t('bank_accounts.account_number'))"
        rules="required" v-slot="{ validated, errors }"
    >
      <b-form-group
          class="row mb-3"
          label-cols-md="2"
          :label="`${lodash.upperFirst($t('bank_accounts.account_number'))}*`"
          :state="errors[0] ? false : (validated ? true : null)"
          :invalid-feedback="errors[0]"
      >
        <b-form-input
            id="account_number"
            :name="`account_number`"
            type="number"
            placeholder="Ex: 35211099811"
            :state="errors[0] ? false : (validated ? true : null)"
            v-model="model.account_number"
        ></b-form-input>
      </b-form-group>
    </validation-provider>
    <hr>
    <validation-provider vid="description" :name="lodash.upperFirst($t('models.description'))" rules="" v-slot="{ validated, errors }">
      <b-form-group
          class="row mb-3"
          :label="lodash.upperFirst($t('models.description'))"
          :state="errors[0] ? false : (validated ? true : null)"
          :invalid-feedback="errors[0]"
      >
        <editor
            ref="editor"
            v-if="$parent.$parent.$options.name !== 'BModal'"
            class="form-control"
            :init="editorInit"
            inline
            plugins="lists link image paste help wordcount"
            toolbar="undo redo | styleselect | fontselect | bold italic | alignleft aligncenter alignright alignjustify | outdent indent"
            v-model="model.description"
        />
        <b-form-textarea v-else v-model="model.description" />
      </b-form-group>
    </validation-provider>
  </validation-observer>
</template>

<script>
import FormModel from './model';
import VueMultiselectAjax from "@/components/inputs/vue-multiselect-ajax";
// import CompanyCreateModal from '../modals/company-create';

export default {
  extends: FormModel,
  components: {
    VueMultiselectAjax
    // CompanyCreateModal
  },
  data() {
    return {
      model: {
        type: 'farmer',
        ...this.value,
        bank_accounts: [
          ...((this.value.bank_accounts || []).length ? this.value.bank_accounts : (this.value.id ? [{ active: true }] : [{}]) ),
        ],
      },
      typeOptions: [
        { text: this.$t('customers.types.farmer'), value: 'farmer' },
        { text: this.$t('customers.types.brs'), value: 'brs' },
        { text: this.$t('customers.types.lcs'), value: 'lcs' },
        { text: this.$t('customers.types.exclusive_lcs'), value: 'exclusive_lcs' },
        { text: this.$t('customers.types.processing'), value: 'processing' }
      ]
    }
  },
  computed: {
    typeRadioOptions() {
      let options = this.typeOptions;

      if (this.model.id && this.model.type === 'jala') {
        options = [
          ...this.typeOptions.map((v) => ({...v, disabled: true})),
          { text: this.lodash.startCase(this.$t('customers.types.jala')), value: 'jala', disabled: true }
        ]
      }

      return options;
    },
    isEditPage() {
      let url = new URL(window.location);
      let path = url.pathname;

      return path.substring(path.lastIndexOf('/') + 1) === 'edit';
    },
  },
  mounted() {
    // setTimeout(() => {
    //   this.$emit('update:errors', {...this.errors, code: ['Diisi coy!!']})
    // }, 5000)
  },
  methods: {
    addItem() {
      if (this.model.id) {
        this.model.bank_accounts.push({ active : true});
      } else {
        this.model.bank_accounts.push({});
      }

    },
    removeItem(index) {
      if (!this.model.bank_accounts.length) return null
      const purchaseItem = this.model.bank_accounts[index]
      if ((purchaseItem || {}).id) {
        this.$set(this.model.bank_accounts[index], '_action', 'delete')
      } else {
        this.model.bank_accounts.splice(index, 1)
      }
    },
  }
}
</script>
